import * as React from "react"
import { useMemo } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Link from "@bappweb/link"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"



const SftpLogin = () => {

  const { t } = useTranslation()
  const size = useDeviceSize()
  const history = useHistory()




  const handleForgotPasswordClick = React.useCallback(() => {
    history.push("/sftp-forgotPassword")
  }, [history])

  const handleChangePasswordClick = React.useCallback(() => {
    history.push("/sftp-changePassword")
  }, [history])



  const main = useMemo(() => {
    return (  
      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{fontSize:"24px",fontFamily:"Campton",textAlign:"center",fontWeight:"550"}}>{t("Sign in to Sftp")}</Element>
        
          <Block >
            <Link onClick={handleForgotPasswordClick}>{t("Forgot Password?")}</Link>
            </Block>
            <Block >
            <Link style={{ marginLeft: "10px" }} onClick={handleChangePasswordClick}>
              {t("Şifremi Değiştir")}
            </Link>
          </Block>
          

        </Block>
      </Block>
    )
  }, [ handleForgotPasswordClick, handleChangePasswordClick, t])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/data-orientedWoman.svg"} fallbackText={t("Oriented Woman")} />
              <Element
                className="sftp-header"
                style={{ fontSize: "34px", color: "black" }}
                type="h2">
                {t("Your files are safe with the file sharing center")}
              </Element>
              <Element style={{ fontSize: "23px", color: "black" }}>
                {t(
                  "Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz."
                )}{" "}
              </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}
    </Page>
  )
}

export default SftpLogin
